import React from "react";
import { tailChase } from "ldrs";

export default function TailChase({ color = "#3B99F7", size = "24" }) {
  tailChase.register();
  return (
    <>
      <l-tail-chase size={size} speed="1.80" color={color}></l-tail-chase>
    </>
  );
}